import React, { useEffect } from 'react'

import { useIntersection } from '@apps-common/hooks/useIntersection'

interface IProps {
  id: any
  padding?: string
  callback: (id: any) => void
}

export const IntersectCallbackCard: React.FC<IProps> = ({ id, padding, callback }) => {
  const triggerRef = React.useRef(null)
  const isVisible = useIntersection(triggerRef, padding || '0px')

  useEffect(() => {
    if (isVisible) {
      callback(id)
    }
  }, [isVisible])

  return <div ref={triggerRef} />
}
